import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { _adr } from "./address";
import PackageIndex from "./pages/packages";
import { useEffect } from "react";
import PackagePrefactor from "./pages/packages/prefactor";
import { checkToken, setToken } from "./tools/services";
import { useAPIPublic } from "./tools/api";
import PackageFactor from "./pages/packages/factor";
import IndexDC from "./pages/directCharge/index";
import FactorCharge from "./pages/directCharge/factorCharge";

export const ScrollToTop = () => {
  // Extracts pathname property(key) from an object
  const { pathname } = useLocation();

  // Automatically scrolls to top whenever pathname changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
};

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path={_adr.Root + _adr.Packages} element={<PackageIndex />} />
          <Route path={_adr.Root + _adr.Packages + _adr.PackagePrefactor} element={<PackagePrefactor />} />
          <Route path={_adr.Root + _adr.Packages + _adr.PackageFactor} element={<PackageFactor />} />
          <Route path={_adr.Root + _adr.DirectCharge} element={<IndexDC />} />
          <Route path={_adr.Root + _adr.DirectCharge + _adr.PackageFactor} element={<FactorCharge />} />
        </Routes>
        <ScrollToTop />
      </Router>
      <ToastContainer />
    </>
  );
}

export default App;
